import { observer } from 'mobx-react-lite';
import React, { useContext, useEffect } from 'react';
import { Grid } from 'semantic-ui-react';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { RootStoreContext } from '../../../app/stores/rootStore';

import PrintList from './PrintList';

const PrintDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    loading,
    loadDepositSalesTicketPrints,
  } = rootStore.depositSalesTicketStore;

  useEffect(() => {
    loadDepositSalesTicketPrints();
  }, [loadDepositSalesTicketPrints]);

  if (loading) return <LoadingComponent content='Loading...' />;

  return (
    <Grid>
      <Grid.Column width={16}>
        <PrintList />
      </Grid.Column>
    </Grid>
  );
};

export default observer(PrintDashboard);
